import React from "react";
import { ds } from "../../DataSource";
import { ParentStateDatasource, DataSourceStateIdle } from "@schneiderpp/utils-endpoint";
import { Endpoint } from "@schneiderpp/admin-endpoint";
import { ROUTER_HOME } from "../home/Router";
import { BaseComponent } from "../../utils/BaseComponent";
import { RouteComponentProps, Link, withRouter } from "react-router-dom";
import { OverlayProps, Overlay } from "@schneiderpp/utils-components";
import { GetURLParams } from "@schneiderpp/utils-generic";

interface DeleteState {
    providedProductSizeId: number | undefined;
    datasource: {
        Details: ParentStateDatasource<typeof Endpoint.Product.GetProductSizeDetails>;
        Delete: ParentStateDatasource<typeof Endpoint.Product.PostProductSizeDelete>;
    };
}

class ProductDelete extends BaseComponent<RouteComponentProps, DeleteState> {
    state: DeleteState = {
        providedProductSizeId: undefined,
        datasource: {
            Details: DataSourceStateIdle,
            Delete: DataSourceStateIdle
        }
    };

    private dsDetails = ds(Endpoint.Product.GetProductSizeDetails, this, "Details", () => this.context);
    private dsDelete = ds(Endpoint.Product.PostProductSizeDelete, this, "Delete", () => this.context);

    componentDidMount() {
        const paramsProductSizeId = GetURLParams("ProductSizeId", "number");
        if (!!paramsProductSizeId) {
            this.setState({ providedProductSizeId: paramsProductSizeId }, () => this.getDetails());
        }
    }

    render() {
        if (!this.state.providedProductSizeId) {
            return (
                <div className="page">
                    <div className="page__header">Nie odnaleziono ProductSizeID</div>
                </div>
            );
        }
        const dsDetails = this.dsDetails.dataSourceStorage;
        if (dsDetails.state === "completed") {
            return (
                <>
                    <div className="header">
                        {" "}
                        <Link
                            to={{ pathname: ROUTER_HOME.Products.Details, search: `ProductId=${this.state.providedProductSizeId}` }}
                            className="button clear no-left-padding"
                        >
                            <span className="button__icon">arrow_back_ios</span> wróć do szczegółów produktu
                        </Link>
                    </div>
                    <div className="page">
                        <div className="page__header">Usuń rozmiar produktu</div>
                        <div className="page-details">
                            <div className="page-details__label">Nazwa</div>
                            <div className="page-details__value">{dsDetails.response.Name}</div>
                        </div>
                        <div className="page-form">
                            <button className="button align-self-end margin-top-10" onClick={() => this.submit()}>
                                usuń
                            </button>
                        </div>
                        <Overlay {...this.overlayProps} />
                    </div>
                </>
            );
        }
        return (
            <div className="page">
                <Overlay {...this.overlayProps} />
            </div>
        );
    }

    get overlayProps(): OverlayProps {
        if (this.dsDetails.state === "pending" || this.dsDetails.state === "idle" || this.dsDelete.state === "pending") {
            return {
                show: true,
                title: "Ładowane..."
            };
        }
        if (this.dsDetails.state === "error") {
            return {
                show: true,
                title: "Coś poszło nie tak",
                description: typeof this.dsDetails.error === "string" ? this.dsDetails.error : "",
                children: (
                    <div className="overlay__children">
                        <button onClick={() => this.getDetails()}>Spróbuj ponownie</button>
                    </div>
                )
            };
        }
        if (this.dsDelete.state === "error") {
            return {
                show: true,
                title: "Coś poszło nie tak",
                description: typeof this.dsDelete.error === "string" ? this.dsDelete.error : "",
                children: (
                    <div className="overlay__children">
                        <button onClick={() => this.dsDelete.resetState()}>Spróbuj ponownie</button>
                    </div>
                )
            };
        }
        return {
            show: false
        };
    }

    private async submit() {
        if (!this.state.providedProductSizeId) {
            return;
        }
        await this.dsDelete.request({
            data: {
                ProductSizeId: this.state.providedProductSizeId
            }
        });
        if (this.dsDelete.dataSourceStorage.state === "completed") {
            const dsDetails = this.dsDetails.dataSourceStorage;
            if (dsDetails.state === "completed") {
                this.props.history.push({ pathname: ROUTER_HOME.Products.Details, search: `ProductId=${dsDetails.response.ProductId}` });
            }
        }
    }

    private async getDetails() {
        if (!this.state.providedProductSizeId) {
            return;
        }
        await this.dsDetails.request({
            params: { ProductSizeId: this.state.providedProductSizeId }
        });
    }
}

export default withRouter(ProductDelete);
